/* eslint-disable max-len */
import React from 'react';

interface ICheckProps {
    color?: string;
    background?: string;
}

const Check: React.FC<ICheckProps> = ({color = '#1DB5B6', background = '#ECFFFE'}) => {
    return (
        <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.5 1C12.8621 1 15.1333 1.88 16.876 3.45801L17.2178 3.78223C18.9994 5.56382 20 7.98044 20 10.5C20 12.8621 19.12 15.1333 17.542 16.876L17.2178 17.2178C15.4362 18.9994 13.0196 20 10.5 20C8.13788 20 5.86672 19.12 4.12402 17.542L3.78223 17.2178C2.00064 15.4362 1 13.0196 1 10.5C1 8.13787 1.88001 5.86672 3.45801 4.12402L3.78223 3.78223C5.56382 2.00063 7.98044 1 10.5 1Z"
                fill={background}
                stroke={color}
            />
            <path
                d="M6.5 10.5L8.77247 13.1512C9.1605 13.6039 9.85595 13.6186 10.2628 13.1828L15.1001 8"
                stroke={color}
                strokeWidth="2.5"
                strokeLinecap="round"
            />
        </svg>

    );
};

export default Check;